<template>
  <Header />
  <div class="section container section--md">
    <div class="content">
      <div class="add-customer-type-container">
        <h2>Add New Type</h2>
        <form class="form" @submit="addNewType" autocomplete="off">
          <div class="form-group">
            <label class="form-label">Name *
              <input v-model="name" class="form-control" :class="displayError ? 'form-control-error' : null" @input="validateInput" v-bind:style="{ 'background-color': activeColor?.hex_value || '#FFF' }">
            </label>
          </div>
          <h2>Select Color</h2>
          <div class="form-group">
            <div v-for="color in colors" @click="setActiveColor(color)" :key="color.id" class="color-container" v-bind:class="{ 'color-container--active': activeColorId == color.id }" v-bind:style="{ 'background-color': color.hex_value }">{{color.name}}</div>
            <div @click="setActiveColor(null)" class="color-container" v-bind:class="{ 'color-container--active': activeColorId == null }" v-bind:style="{ 'background-color': '#FFF' }">Blank</div>
          </div>
          <div class="buttons">
            <p class="error-message" v-if="displayError">Please correct the highlighted field.</p>
            <button type="submit" class="btn btn--primary" :disabled="name === null || name == '' || displayError">Save</button>
            <button @click="cancel" class="btn btn--warning">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import api from '../api'
export default {
  name: 'AddCustomerType',
  components: {
    Header
  },
  emits: ['customerTypeCancel'],
  data() {
    return {
      name: null,
      displayError: false,
      colors: [],
      activeColorId: null,
      activeColor: null,
    }
  },
  mounted() {
    api.getTypeColors().then(response => {
      this.colors = response.data.records
    })
  },
  methods: {
    addNewType(e) {
      e.preventDefault()
      api.createCustomerType({ name: this.name, type_color_id: this.activeColorId }).then(res => {
        console.log(res);
        this.$router.push(`/admin?added_type_id=${res.data.record.id}`)
      })
    },
    cancel() {
      this.$router.push('/admin')
    },
    validateInput() {
      if (!/^[a-zA-Z\s&\d]*$/.test(this.name)) {
        this.displayError = true
        return
      }
      this.displayError = false
    },
    setActiveColor(color) {
      this.activeColor = color
      this.activeColorId = color?.id || null
    }
  },
}
</script>
<style scoped>
.customer-type-container {
  margin-top: 0.4375rem;
  border: 1px solid #E5E5E5;
  position: relative;
  background: white;
  padding-left: 15px;
}

.color-container {
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  height: 40px;
  margin: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-left: 20px;
}

.color-container--active {
  border: 1px solid black;
}

.color-container:hover {
  border: 1px solid black;
}

.form-control-error {
  border: 1px solid #D43F21;
}

.error-message {
  color: red;
  margin-bottom: 10px;
}
</style>
